export default "__VITE_ASSET__DZYTJnjF__"